"use client"
import { ProductData } from "@/lib/content-service/types/ContentServiceProduct"
import logger from "@/lib/logger/logger-init"
import { Order } from "@/types/centra/checkout-api/payment/payment-reciept"
import {
    CheckoutAPIProduct,
    RelatedProduct
} from "@/types/centra/checkout-api/products/post-products"

export const viewItemDepictEvent = (
    product: CheckoutAPIProduct | RelatedProduct | ProductData,
    item: any
) => {
    if (typeof window.dpq === "function") {
        window.dpq("setProductId", item?.sku || product.sku)
        logger.debug("viewItemDepictEvent", item?.sku || product.sku)
    } else {
        logger.error("Depict dpq function not found")
    }
}

export const addToCartDepictEvent = (
    product: CheckoutAPIProduct | RelatedProduct | ProductData,
    item: any
) => {
    if (typeof window.dpq === "function") {
        window.dpq("addToCart", item?.sku || product.sku)
        logger.debug("addToCartDepictEvent", item?.sku || product.sku)
    } else {
        logger.error("Depict dpq function not found")
    }
}

export const purchaseDepictEvent = (order: Order | undefined) => {
    if (!order) return
    if (!window.dpq) {
        logger.error("depict not loaded")
        return
    }
    const items =
        order?.items.map(item => ({
            item_id: item.sku,
            price: item.priceEachAsNumber,
            quantity: item.quantity
        })) || []
    window.dpq("purchase", {
        transaction_id: order?.order,
        items: items,
        currency: order?.currency
    })
    logger.debug("purchaseDepictEvent", {
        transaction_id: order?.order,
        items: items,
        currency: order?.currency
    })
}
